export const YouTube = () => (
  <svg
    width="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5822 11.1861C25.3522 10.3256 24.6745 9.64797 23.814 9.41797C22.2541 9 16 9 16 9C16 9 9.74582 9 8.18598 9.41797C7.32559 9.64797 6.64781 10.3256 6.41785 11.1861C6 12.7458 6 16.0001 6 16.0001C6 16.0001 6 19.2543 6.41785 20.8139C6.64781 21.6744 7.32559 22.3522 8.18598 22.5822C9.74582 23 16 23 16 23C16 23 22.2541 23 23.814 22.5822C24.6745 22.3522 25.3522 21.6744 25.5822 20.8139C26 19.2543 26 16.0001 26 16.0001C26 16.0001 26 12.7458 25.5822 11.1861ZM13.9999 19.0002V13L19.1959 16.0001L13.9999 19.0002Z"
      fill="currentColor"
    />
  </svg>
)
